/**
 * Backend adjustment type for a membership discount on a cart / sale order.
 * Confirmed against @water-web/mobile (ValidatedCartAdjustmentMembership).
 */
export const MEMBERSHIP_DISCOUNT_ADJUSTMENT_TYPE = 'membership_discount';

type AdjustmentLike = { type: string; amount: number };

/**
 * Sum of membership_discount adjustments as a POSITIVE cents value (0 if none).
 * Adjustment amounts are negative on the wire, so we take the absolute value —
 * mirrors getMembershipPriceFromCart in @water-web/repository.
 */
export const getMembershipDiscount = (
  adjustments?: readonly AdjustmentLike[],
): number =>
  Math.abs(
    (adjustments ?? [])
      .filter((adj) => adj.type === MEMBERSHIP_DISCOUNT_ADJUSTMENT_TYPE)
      .reduce((sum, adj) => sum + adj.amount, 0),
  );
